module.exports = __webpack_public_path__ + "img/neckcurve.eabe70a1.png";